import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SeriesService } from '../series.service';
import { Series } from '../series.interface';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-change-current-number',
    templateUrl: './change-current-number.component.html',
    styleUrls: ['./change-current-number.component.scss']
})
export class ChangeCurrentNumberComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    token!: string;
    isLoading = false;
    helper = helper;

    form: FormGroup = new FormGroup({
        current_number: new FormControl(this.data.current_number, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: Series,
        private dialogRef: MatDialogRef<ChangeCurrentNumberComponent>,
        private notificationService: NotificationService,
        private authService: AuthService,
        private requestService: SeriesService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    submitForm() {
        this.isLoading = true;

        const { current_number } = this.form.value;
        const payload = {
            current_number
        };

        this.requestService
            .updateNumarCurent(this.data.id, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
